module.exports = __webpack_public_path__ + "assets/img/inventory.f4a06117.svg";